import clsx from 'clsx'
import React, {useContext} from 'react'
import {hasActiveStandardsFilter} from 'components/standards-selector/domain/active-filters.cjs'
import {Link} from 'react-router-dom'
import SearchPattern from 'components/quiz/components/search-pattern'
import Box from '@mui/material/Box'


import {TeacherContext} from 'teacher/context'

export default function PatternFilter (props) {
 
  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {translate, quizQuestionTypes: questionTypes} = context
  return (
    <Box className={classes.patternFilter}>
      <Box className={classes.pattern}>
        <SearchPattern path={context.link()} context={context} />
      </Box>
      {!hasActiveStandardsFilter(context.quizStandardFilters) && <Box className={classes.standardsSearch}>
        <Link to={context.link({sectionName: 'standards-search'},'/:languageId/:role/:page/:tab/:sectionName', {preserveQuery:true})} className={classes.standardsSearchLink}>
          {translate('standards-search')}
        </Link>
      </Box>}
    </Box>
  )
}
